import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import useRemoveDexviewscore from '../hooks/useRemoveDexviewscore';

interface IProps {
  isOpen: boolean;
  currentId: string | undefined;
  onClose: () => void;
}
export default function ModalRemoveDexviewscore({
  isOpen,
  onClose,
  currentId,
}: IProps) {
  const { mutate, isLoading } = useRemoveDexviewscore({ onClose, id: currentId });
  const handleRemove = () => {
    mutate();
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure? You can't undo this action afterwards.
        </ModalBody>
        <ModalFooter>
          <Button
            variant='solid'
            colorScheme='red'
            onClick={handleRemove}
            isLoading={isLoading}
          >
            Delete
          </Button>
          <Button ml={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
